'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

let flashMessageTimeout;

export function flashMessage(message, kind = 'notice') {
  $('.flash').remove();
  const flash = document.querySelector('[data-admin-flash]');
  const level = kind === 'alert' ? 'error' : 'success';
  flash.dispatchEvent(new CustomEvent('flash:show', { detail: { message, level } }));

  clearTimeout(flashMessageTimeout);
  flashMessageTimeout = setTimeout(() => flash.dispatchEvent(new CustomEvent('flash:hide')), 5000);
}

onPageLoad(() => {
  $(document).on('change', 'input[name=debug_search_rank]', (e) => {
    const $form = $(e.currentTarget).parents('form');
    $form.submit();
  });

  $(document).on('change', '.field--change-admin, .green-checkbox--is-retailer', (e) => {
    $(e.target).parents('form').submit();
  });

  $(document).on('submit', '.cancel-stripe-subscription-form', (e) => {
    return confirm(
      'Cancel paid subscription on Stripe? Designer will have to sign up from scratch with her CC to renew it.'
    );
  });
});
